"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var ArticleList_1 = __importDefault(require("./widgets/ArticleList"));

exports.WidgetArticleList = ArticleList_1["default"];

var CalendarEventList_1 = __importDefault(require("./widgets/CalendarEventList"));

exports.WidgetCalendarEventList = CalendarEventList_1["default"];

var DangerousSource_1 = __importDefault(require("./widgets/DangerousSource"));

exports.WidgetDangerousSource = DangerousSource_1["default"];

var Document_1 = __importDefault(require("./widgets/Document"));

exports.WidgetDocument = Document_1["default"];

var External_1 = __importDefault(require("./widgets/External"));

exports.WidgetExternal = External_1["default"];

var Social_1 = __importDefault(require("./widgets/Social"));

exports.WidgetSocial = Social_1["default"];

var FAQ_1 = __importDefault(require("./widgets/FAQ"));

exports.WidgetFAQ = FAQ_1["default"];

var FormattedText_1 = __importDefault(require("./widgets/FormattedText"));

exports.WidgetFormattedText = FormattedText_1["default"];

var ImageAd_1 = __importDefault(require("./widgets/ImageAd"));

exports.WidgetImageAd = ImageAd_1["default"];

var Multiblock_1 = __importDefault(require("./widgets/Multiblock"));

exports.WidgetMultiblock = Multiblock_1["default"];

var Partners_1 = __importDefault(require("./widgets/Partners"));

exports.WidgetPartners = Partners_1["default"];

var Persons_1 = __importDefault(require("./widgets/Persons"));

exports.WidgetPersons = Persons_1["default"];

var Photo_1 = __importDefault(require("./widgets/Photo"));

exports.WidgetPhoto = Photo_1["default"];

var PhotoGallery_1 = __importDefault(require("./widgets/PhotoGallery"));

exports.WidgetPhotoGallery = PhotoGallery_1["default"];

var RotatingArticle_1 = __importDefault(require("./widgets/RotatingArticle"));

exports.WidgetRotatingArticle = RotatingArticle_1["default"];

var SectionList_1 = __importDefault(require("./widgets/SectionList"));

exports.WidgetSectionList = SectionList_1["default"];

var SportRecords_1 = __importDefault(require("./widgets/SportRecords"));

exports.WidgetSportRecords = SportRecords_1["default"];

var Table_1 = __importDefault(require("./widgets/Table"));

exports.WidgetTable = Table_1["default"];

var Television_1 = __importDefault(require("./widgets/Television"));

exports.WidgetTelevision = Television_1["default"];

var Video_1 = __importDefault(require("./widgets/Video"));

exports.WidgetVideo = Video_1["default"];

var Visualizer_1 = __importDefault(require("./widgets/Visualizer"));

exports.WidgetVisualizer = Visualizer_1["default"];

var Voting_1 = __importDefault(require("./widgets/Voting"));

exports.WidgetVoting = Voting_1["default"];

var widgets_1 = __importDefault(require("./widgets"));

exports["default"] = widgets_1["default"];